import React, { useState, useEffect } from 'react';
import {
  FiPieChart, FiBarChart2, FiShare2, FiGrid, FiUsers, 
  FiAward, FiEdit3, FiLogOut, FiRefreshCw, FiShield, FiPlus, 
  FiX, FiTrash2, FiCamera, FiChevronDown, FiMenu, FiGlobe
} from 'react-icons/fi';
import { MdQrCode } from 'react-icons/md';
import { AiFillAndroid, AiFillApple } from 'react-icons/ai';
import { QRCodeSVG } from 'qrcode.react';

// Firebase Firestore
import { doc, getDoc, updateDoc, collection, getDocs, query, where } from 'firebase/firestore';
import { db, auth } from '../../firebase';

// Kép import
import targetBg from '../../target_bg_profil.png';

// --- EGYEDI SVG IKONOK (AZ APP XML-JEI ALAPJÁN) ---

const IconPieChart = ({ size = 24, color = "#D32F2F" }) => (
  <svg width={size} height={size} viewBox="0 0 960 960" fill={color}>
    <path d="M520,440L798,440Q783,330 706.5,253.5Q630,177 520,162L520,440ZM440,798L440,162Q319,177 239.5,267.5Q160,358 160,480Q160,602 239.5,692.5Q319,783 440,798ZM520,798Q630,784 707,707Q784,630 798,520L520,520L520,798ZM480,880Q397,880 324,848.5Q251,817 197,763Q143,709 111.5,636Q80,563 80,480Q80,397 111.5,324Q143,251 197,197Q251,143 324,111.5Q397,80 480,80Q563,80 635.5,111.5Q708,143 762.5,197.5Q817,252 848.5,324.5Q880,397 880,480Q880,562 848.5,635Q817,708 763,762.5Q709,817 636,848.5Q563,880 480,880Z"/>
  </svg>
);

const IconDetailedStats = ({ size = 24, color = "#D32F2F" }) => (
  <svg width={size} height={size} viewBox="0 0 960 960" fill={color}>
    <path d="M200,840Q167,840 143.5,816.5Q120,793 120,760L120,200Q120,167 143.5,143.5Q167,120 200,120L560,120L560,200L200,200L200,760L760,760L760,400L840,400L840,760Q840,793 816.5,816.5Q793,840 760,840L200,840ZM280,680L360,680L360,400L280,400L280,680ZM440,680L520,680L520,280L440,280L440,680ZM600,680L680,680L680,520L600,520L600,680ZM680,360L680,280L600,280L600,200L680,200L680,120L760,120L760,200L840,200L840,280L760,280L760,360L680,360Z"/>
  </svg>
);

const IconCommunity = ({ size = 24, color = "#D32F2F" }) => (
  <svg width={size} height={size} viewBox="0 0 960 960" fill={color}>
    <path d="M411,480Q383,480 365,459Q347,438 352,410L364,338Q372,295 404.5,267.5Q437,240 480,240Q524,240 556.5,267.5Q589,295 597,338L609,410Q614,438 596,459Q578,480 550,480L411,480ZM435,400L526,400L518,351Q516,337 505,328.5Q494,320 480,320Q466,320 455.5,328.5Q445,337 443,351L435,400ZM124,519Q101,520 84.5,510Q68,500 63,479Q61,470 62,461Q63,452 67,444Q67,445 66,440Q64,438 56,416Q54,404 59,393Q64,382 72,374Q72,374 74,372Q76,353 89.5,340Q103,327 123,327Q126,327 142,331Q142,331 145,330Q150,325 158,322.5Q166,320 175,320Q186,320 194.5,323.5Q203,327 208,334Q209,334 209.5,334.5Q210,335 211,335Q225,336 235.5,343.5Q246,351 251,364Q253,371 252.5,377.5Q252,384 252,384L250,390Q250,391 251,394Q258,401 262,409.5Q266,418 266,427Q266,431 260,448Q259,450 260,452Q260,452 262,468Q262,489 244.5,504Q227,519 202,519L124,519ZM800,520Q767,520 743.5,496.5Q720,473 720,440Q720,428 723.5,417.5Q727,407 733,397L705,372Q695,364 701.5,352Q708,340 720,340L800,340Q833,340 856.5,363.5Q880,387 880,420L880,440Q880,473 856.5,496.5Q833,520 800,520ZM0,720L0,657Q0,613 44.5,586.5Q89,560 160,560Q173,560 185,560.5Q197,561 208,563Q194,583 187,606Q180,629 180,655L180,720L0,720ZM240,720L240,655Q240,590 306.5,550Q373,510 480,510Q588,510 654,550Q720,590 720,655L720,720L240,720ZM800,560Q872,560 916,586.5Q960,613 960,657L960,720L780,720L780,655Q780,629 773.5,606Q767,583 754,563Q765,561 776.5,560.5Q788,560 800,560ZM480,590Q423,590 378,605Q333,620 325,640L325,640L636,640L636,640Q627,620 582.5,605Q538,590 480,590Z"/>
  </svg>
);

const IconShare = ({ size = 24, color = "#D32F2F" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="18" cy="5" r="3"></circle>
    <circle cx="6" cy="12" r="3"></circle>
    <circle cx="18" cy="19" r="3"></circle>
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
  </svg>
);

const IconTrophies = ({ size = 24, color = "#D32F2F" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M19,5h-2V3H7v2H5C3.9,5 3,5.9 3,7v1c0,2.55 1.92,4.63 4.39,4.94c0.63,1.5 1.98,2.63 3.61,2.96V19H7v2h10v-2h-4v-3.1c1.63,-0.33 2.98,-1.46 3.61,-2.96C19.08,12.63 21,10.55 21,8V7C21,5.9 20.1,5 19,5zM5,8V7h2v3.82C5.84,10.4 5,9.3 5,8zM19,8c0,1.3 -0.84,2.4 -2,2.82V7h2V8z"/>
  </svg>
);

const IconMedal = ({ size = 24, color = "#D32F2F" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12,13L3,2h3l6,7 6,-7h3L12,13z"/>
    <path d="M12,13c-3.31,0 -6,2.69 -6,6s2.69,6 6,6 6,-2.69 6,-6 -2.69,-6 -6,-6zm0,10c-2.21,0 -4,-1.79 -4,-4s1.79,-4 4,-4 4,1.79 4,4 -1.79,4 -4,4z"/>
    <path d="M12,21l-2.31,1.21 0.44,-2.57 -1.87,-1.83 2.59,-0.38 1.16,-2.35 1.16,2.35 2.59,0.38 -1.87,1.83 0.44,2.57z"/>
  </svg>
);

const CompetitorDashboard = ({ currentUser, onLogout, onNavigateToAdmin }) => {
  const userId = currentUser?.uid || currentUser?.id || null;

  // --- ÁLLAPOTOK ---
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [menuExpanded, setMenuOpen] = useState(false);
  const [userData, setUserData] = useState({
    fullName: currentUser?.displayName || "Íjász",
    club: "----",
    license: "Licenszsz.: -",
    profileImageUrl: currentUser?.photoURL || null,
    totalShots: 0,
    trophies: [],
    isAdmin: false,
    registeredVia: null
  });

  const [chartMode, setChartMode] = useState('classic');
  const [activeTab, setActiveTab] = useState('none');
  const [showManualModal, setShowManualModal] = useState(false);
  const [manualInputValue, setManualInputValue] = useState('');
  const [selectedPieSlice, setSelectedPieSlice] = useState(null);

  const [chartStats, setChartStats] = useState({ classic: [], all: [], totalProcessed: 0 });
  const [userCompetitions, setUserCompetitions] = useState([]);

  // --- ADATBETÖLTÉS A FIRESTORE-BÓL ---
  useEffect(() => {
    let isMounted = true;
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);

    const fetchDashboardData = async () => {
      if (!userId) {
        if (isMounted) setLoading(false);
        return;
      }

      try {
        const userDocRef = doc(db, 'users', userId);
        const userSnap = await getDoc(userDocRef);

        if (userSnap.exists() && isMounted) {
          const uData = userSnap.data() || {};
          const adminUids = ["c4sTvlqVBwZIQUSbqHA56MOw9wH3", "1o1A3CmOmJWqxv5TR0INePU70iP2"];

          const lastName = uData.lastName || '';
          const firstName = uData.firstName || '';
          const fullName = `${lastName} ${firstName}`.trim() || currentUser?.displayName || "Névtelen Íjász";

          setUserData({
            fullName: fullName,
            club: uData.club || "----",
            license: uData.license ? `Licenszsz.: ${uData.license}` : "Licenszsz.: -",
            profileImageUrl: uData.profileImageUrl || null,
            totalShots: typeof uData.totalShots === 'number' ? uData.totalShots : 0,
            trophies: Array.isArray(uData.selectedTrophies) ? uData.selectedTrophies : [],
            isAdmin: adminUids.includes(userId),
            registeredVia: uData.registeredVia || null
          });

          // Kördiagram adatok
          const fullStats = uData.fullStats || {};
          const classicMap = {};
          const allMap = {};
          let totalCount = 0;

          Object.keys(fullStats).forEach(key => {
            const count = parseInt(fullStats[key], 10) || 0;
            totalCount += count;
            allMap[key] = count;
            if (['11', '10', '8', '5', '0'].includes(key)) classicMap[key] = count;
          });

          const getColor = (label) => {
            switch (label) {
              case '11': case 'X': return '#FFD700';
              case '10': return '#FFEB3B';
              case '8': return '#F44336';
              case '5': return '#1976D2';
              case '0': return '#9E9E9E';
              default: return '#4CAF50';
            }
          };

          const formatSlices = (map) => Object.keys(map).map(label => ({
            name: label,
            value: map[label],
            color: getColor(label)
          }));

          setChartStats({
            classic: formatSlices(classicMap),
            all: formatSlices(allMap),
            totalProcessed: totalCount
          });

          // Versenyek lekérése
          const partsRef = collection(db, "events");
          const qComp = query(partsRef, where("status", "==", "Aktív"));
          const compSnap = await getDocs(qComp);
          const activeComps = [];
          compSnap.forEach(doc => activeComps.push({ id: doc.id, ...doc.data() }));
          setUserCompetitions(activeComps);
        }
      } catch (error) {
        console.error("Hiba:", error);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchDashboardData();
    return () => {
      isMounted = false;
      window.removeEventListener('resize', handleResize);
    };
  }, [userId]);

  const xorCipher = (data) => {
    const key = "ARCHERY_NEXUS_2024_SAFE_KEY";
    let output = "";
    for (let i = 0; i < data.length; i++) {
      output += String.fromCharCode(data.charCodeAt(i) ^ key.charCodeAt(i % key.length));
    }
    return output;
  };

  const getEncryptedQrString = () => {
    if (!userId) return "";
    const rawData = `ANX|${userId}|${userData.fullName}`;
    return btoa(unescape(encodeURIComponent(xorCipher(rawData))));
  };

  const handleManualSave = async () => {
    const val = parseInt(manualInputValue, 10);
    if (!isNaN(val) && val >= 0 && userId) {
      const userRef = doc(db, 'users', userId);
      await updateDoc(userRef, { totalShots: val });
      setUserData(prev => ({ ...prev, totalShots: val }));
      setShowManualModal(false);
    }
  };

  if (loading) return <div style={loadingStyle_full}>Betöltés... 🏹</div>;

  const formattedShots = String(Math.max(0, userData.totalShots)).padStart(isMobile ? 8 : 10, '0').split('');

  const renderPie = () => {
    const data = chartStats[chartMode] || [];
    const total = data.reduce((acc, s) => acc + s.value, 0);
    if (total === 0) return <p style={{ color: '#888', padding: '20px' }}>Nincs adat.</p>;
    let currentAngle = 0;
    return (
      <svg width="200" height="200" viewBox="-1.1 -1.1 2.2 2.2" style={{ transform: 'rotate(-90deg)' }}>
        {data.map((s, i) => {
          const angle = (s.value / total) * 2 * Math.PI;
          const x1 = Math.cos(currentAngle);
          const y1 = Math.sin(currentAngle);
          const x2 = Math.cos(currentAngle + angle);
          const y2 = Math.sin(currentAngle + angle);
          const largeArc = angle > Math.PI ? 1 : 0;
          const path = `M 0 0 L ${x1} ${y1} A 1 1 0 ${largeArc} 1 ${x2} ${y2} Z`;
          currentAngle += angle;
          return <path key={i} d={path} fill={s.color} stroke="#fff" strokeWidth="0.02" onClick={() => setSelectedPieSlice(s)} style={{ cursor: 'pointer' }} />;
        })}
        <circle cx="0" cy="0" r="0.6" fill="#fff" />
      </svg>
    );
  };

  return (
    <div className="force-light-theme" style={pageWrapperStyle}>

      {/* 1. HÁTTÉRKÉP SZÉLES FEJLÉCCEL */}
      <div style={appBarBackgroundStyle}>
        <div style={overlayStyle} />

        {/* TRÓFEÁK (Bal felső) */}
        <div style={isMobile ? mobileTrophyContainer : desktopTrophyContainer}>
           {userData.trophies.slice(0, 3).map((t, i) => (
             <div key={i} style={trophyIconStyle}><IconTrophies size={32} /></div>
           ))}
        </div>

        {/* FAB MENÜ (Jobb felső) */}
        <div style={fabMenuContainer}>
          <button style={fabMainBtn} onClick={() => setMenuOpen(!menuExpanded)}>
            <FiMenu size={20} />
          </button>
          {menuExpanded && (
            <div style={expandedMenu}>
               <button style={fabSubBtn} onClick={() => alert('Szerkesztés')} title="Szerkesztés"><FiEdit3 size={16} /></button>
               <button style={fabSubBtn} onClick={() => alert('Adatátvitel')} title="Adatátvitel"><FiRefreshCw size={16} /></button>
               {userData.isAdmin && <button style={{...fabSubBtn, backgroundColor: '#2E7D32'}} onClick={onNavigateToAdmin} title="Admin"><FiShield size={16} /></button>}
               <button style={{...fabSubBtn, backgroundColor: '#d32f2f'}} onClick={onLogout} title="Kijelentkezés"><FiLogOut size={16} /></button>
            </div>
          )}
        </div>

        {/* PROFIL INFÓ */}
        <div style={isMobile ? mobileHeaderContent : desktopHeaderContent}>
          <div style={isMobile ? mobileTextDetails : desktopTextDetails}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
               <h1 style={userNameStyle}>{userData.fullName}</h1>
               {userData.registeredVia === 'android' && <AiFillAndroid size={20} color="#3DDC84" title="Android App" />}
               {userData.registeredVia === 'ios' && <AiFillApple size={20} color="#999999" title="iOS Web" />}
               {userData.registeredVia === 'web' && <FiGlobe size={20} color="#007bff" title="Web" />}
            </div>
            <p style={userClubStyle}>{userData.club}</p>
            <p style={userLicenseStyle}>{userData.license}</p>
          </div>

          <div style={profileImageWrapperStyle}>
            <div style={profileCircleStyle}>
              <img src={userData.profileImageUrl || "https://via.placeholder.com/120"} alt="Profil" style={imgStyle} />
            </div>
            <button style={smallCameraBtn}><FiCamera size={14} color="#fff" /></button>
            <button style={smallQrBtn} onClick={() => setActiveTab(activeTab === 'qr' ? 'none' : 'qr')}><MdQrCode size={14} color="#fff" /></button>
          </div>
        </div>
      </div>

      {/* 2. LÖVÉSSZÁMLÁLÓ KÁRTYA */}
      <div style={isMobile ? mobileCounterCard : desktopCounterCard} onClick={() => setShowManualModal(true)}>
        <div style={counterLabelRow}>
          <FiEdit3 size={12} color="#888" />
          <span style={counterLabelText}>ÖSSZES LÖVÉS</span>
        </div>
        
        <div style={odometerContainer}>
          {formattedShots.map((d, i) => (
            <div key={i} style={odometerBox}>{d}</div>
          ))}
        </div>

        <div style={isMobile ? mobileActionGrid : desktopActionGrid}>
          <button style={actionBtn(activeTab === 'chart')} onClick={(e) => { e.stopPropagation(); setActiveTab(activeTab === 'chart' ? 'none' : 'chart'); }}>
            <IconPieChart size={28} />
            <span style={actionBtnText}>Kördiagram</span>
          </button>
          <button style={actionBtn(activeTab === 'stats')} onClick={(e) => { e.stopPropagation(); setActiveTab(activeTab === 'stats' ? 'none' : 'stats'); }}>
            <IconDetailedStats size={28} />
            <span style={actionBtnText}>Összesített</span>
          </button>
          <button style={actionBtn(false)} onClick={(e) => e.stopPropagation()}>
            <IconCommunity size={28} />
            <span style={actionBtnText}>Közösség</span>
          </button>
          <button style={actionBtn(activeTab === 'shared')} onClick={(e) => { e.stopPropagation(); setActiveTab(activeTab === 'shared' ? 'none' : 'shared'); }}>
            <IconShare size={28} />
            <span style={actionBtnText}>Megosztások</span>
          </button>
          <button style={actionBtn(false)} onClick={(e) => e.stopPropagation()}>
            <IconTrophies size={28} />
            <span style={actionBtnText}>Trófeák</span>
          </button>
          <button style={actionBtn(activeTab === 'competitions')} onClick={(e) => { e.stopPropagation(); setActiveTab(activeTab === 'competitions' ? 'none' : 'competitions'); }}>
            <IconMedal size={28} />
            <span style={actionBtnText}>Versenyek</span>
          </button>
        </div>
      </div>

      {/* 3. TARTALMI KÁRTYÁK */}
      <div style={scrollContentStyle}>
        {activeTab === 'chart' && (
          <div style={contentCard}>
            <div style={cardHeader}>
               <h4 style={cardTitle}>Lövések eloszlása</h4>
               <button style={chartModeBtn} onClick={() => setChartMode(chartMode === 'classic' ? 'all' : 'classic')}>
                 {chartMode === 'classic' ? 'Klasszikus' : 'Minden'}
               </button>
            </div>
            <div style={chartContent}>
              {renderPie()}
              <div style={chartStatsList}>
                {(chartStats[chartMode] || []).map((s, i) => (
                  <div key={i} style={statItemStyle}><div style={{...dot, backgroundColor: s.color}} /> {s.name}: {s.value}</div>
                ))}
              </div>
            </div>
          </div>
        )}

        {activeTab === 'qr' && (
          <div style={{...contentCard, textAlign: 'center'}}>
            <h4 style={cardTitle}>Saját QR Kód</h4>
            <div style={qrWrapper}><QRCodeSVG value={getEncryptedQrString()} size={180} /></div>
            <p style={qrInfo}>Ezzel tudnak a versenyeken azonosítani.</p>
          </div>
        )}

        {activeTab === 'competitions' && (
          <div style={contentCard}>
            <h4 style={cardTitle}>Aktuális versenyeid</h4>
            {userCompetitions.length > 0 ? (
              userCompetitions.map(c => (
                <div key={c.id} style={compRow}>
                  <strong>{c.competitionName}</strong>
                  <span>{c.competitionDate}</span>
                </div>
              ))
            ) : <p style={emptyText}>Nincsenek aktív versenyeid.</p>}
          </div>
        )}
      </div>

      {/* MODAL */}
      {showManualModal && (
        <div style={modalBackdrop}>
          <div style={modalInner}>
            <h3>Összes lövésszám</h3>
            <input type="number" value={manualInputValue} onChange={(e) => setManualInputValue(e.target.value)} style={modalInput} />
            <div style={modalBtns}>
               <button onClick={() => setShowManualModal(false)} style={cancelBtn}>Mégse</button>
               <button onClick={handleManualSave} style={saveBtn}>Mentés</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// --- STÍLUSOK ---

const pageWrapperStyle = { backgroundColor: '#f4f6f8', minHeight: '100vh', fontFamily: 'Arial, sans-serif', display: 'flex', flexDirection: 'column' };
const appBarBackgroundStyle = { height: '180px', width: '100%', position: 'relative', backgroundImage: `url(${targetBg})`, backgroundSize: 'cover', backgroundPosition: 'center' };
const overlayStyle = { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.45)' };
const desktopTrophyContainer = { position: 'absolute', top: '15px', left: '20px', display: 'flex', gap: '5px', zIndex: 10 };
const mobileTrophyContainer = { position: 'absolute', top: '10px', left: '12px', display: 'flex', gap: '4px', zIndex: 10 };
const trophyIconStyle = { width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' };
const fabMenuContainer = { position: 'absolute', top: '15px', right: '15px', zIndex: 100, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' };
const fabMainBtn = { width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#D32F2F', border: 'none', color: '#fff', cursor: 'pointer', boxShadow: '0 4px 8px rgba(0,0,0,0.3)' };
const expandedMenu = { display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '8px' };
const fabSubBtn = { width: '36px', height: '36px', borderRadius: '50%', backgroundColor: '#D32F2F', border: 'none', color: '#fff', cursor: 'pointer', boxShadow: '0 3px 6px rgba(0,0,0,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' };
const desktopHeaderContent = { position: 'absolute', bottom: '15px', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', padding: '0 30px', boxSizing: 'border-box' };
const mobileHeaderContent = { position: 'absolute', bottom: '15px', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', padding: '0 20px', boxSizing: 'border-box' };
const desktopTextDetails = { color: '#fff', textAlign: 'left' };
const mobileTextDetails = { color: '#fff', textAlign: 'left', textShadow: '0 1px 3px rgba(0,0,0,0.8)', flex: 1, paddingRight: '10px', marginBottom: '0' };
const userNameStyle = { margin: 0, fontSize: '22px', fontWeight: 'bold' };
const userClubStyle = { margin: '2px 0', fontSize: '13px', fontStyle: 'italic', opacity: 0.9 };
const userLicenseStyle = { margin: 0, fontSize: '13px', opacity: 0.8 };
const profileImageWrapperStyle = { position: 'relative', width: '100px', height: '100px' };
const profileCircleStyle = { width: '100px', height: '100px', borderRadius: '50%', border: '3px solid #fff', overflow: 'hidden', backgroundColor: '#eee', boxShadow: '0 4px 10px rgba(0,0,0,0.3)' };
const imgStyle = { width: '100%', height: '100%', objectFit: 'cover' };
const smallCameraBtn = { position: 'absolute', bottom: '2px', right: '-5px', width: '28px', height: '28px', borderRadius: '50%', backgroundColor: '#D32F2F', border: '2px solid #fff', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' };
const smallQrBtn = { position: 'absolute', bottom: '2px', left: '-5px', width: '28px', height: '28px', borderRadius: '50%', backgroundColor: '#D32F2F', border: '2px solid #fff', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' };
const desktopCounterCard = { margin: '20px 30px', backgroundColor: '#fff', borderRadius: '12px', padding: '20px', boxShadow: '0 8px 24px rgba(0,0,0,0.1)' };
const mobileCounterCard = { margin: '20px 12px 15px 12px', backgroundColor: '#fff', borderRadius: '12px', padding: '15px', boxShadow: '0 10px 25px rgba(0,0,0,0.1)' };
const counterLabelRow = { display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '10px' };
const counterLabelText = { fontSize: '11px', fontWeight: 'bold', color: '#888' };
const odometerContainer = { display: 'flex', justifyContent: 'center', gap: '4px', backgroundColor: '#222', padding: '10px', borderRadius: '8px', marginBottom: '20px' };
const odometerBox = { width: '28px', height: '40px', backgroundColor: '#000', color: '#fff', fontSize: '24px', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px', border: '1px solid #444' };
const desktopActionGrid = { display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '10px' };
const mobileActionGrid = { display: 'grid', gridTemplateColumns: 'repeat(3, 2fr)', gap: '10px' };
const actionBtn = (active) => ({ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px', background: active ? '#fbeaea' : 'none', border: 'none', cursor: 'pointer', padding: '10px 5px', borderRadius: '8px' });
const actionBtnText = { fontSize: '10px', color: '#666', fontWeight: 'bold' };
const scrollContentStyle = { padding: '0 20px 40px 20px', flex: 1 };
const contentCard = { backgroundColor: '#fff', borderRadius: '12px', padding: '20px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', marginBottom: '20px' };
const cardTitle = { margin: '0 0 15px 0', color: '#b30000', fontSize: '16px', borderBottom: '1px solid #eee', paddingBottom: '10px' };
const cardHeader = { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' };
const chartModeBtn = { padding: '4px 10px', borderRadius: '12px', border: '1px solid #D32F2F', color: '#D32F2F', fontSize: '11px', background: 'none', cursor: 'pointer' };
const chartContent = { display: 'flex', flexWrap: 'wrap', gap: '20px', alignItems: 'center', justifyContent: 'center' };
const chartStatsList = { display: 'flex', flexDirection: 'column', gap: '8px' };
const statItemStyle = { fontSize: '13px', color: '#444', display: 'flex', alignItems: 'center', gap: '8px' };
const dot = { width: '12px', height: '12px', borderRadius: '3px' };
const qrWrapper = { padding: '20px', background: '#f9f9f9', borderRadius: '12px', display: 'inline-block', border: '1px solid #eee' };
const qrInfo = { marginTop: '10px', fontSize: '13px', color: '#888' };
const compRow = { display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #f0f0f0' };
const emptyText = { textAlign: 'center', color: '#aaa', fontStyle: 'italic' };
const modalBackdrop = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 };
const modalInner = { background: '#fff', padding: '25px', borderRadius: '16px', width: '90%', maxWidth: '350px', textAlign: 'center' };
const modalInput = { width: '100%', padding: '12px', fontSize: '20px', fontWeight: 'bold', textAlign: 'center', border: '1px solid #ddd', borderRadius: '8px', marginBottom: '20px' };
const modalBtns = { display: 'flex', gap: '10px' };
const cancelBtn = { flex: 1, padding: '12px', border: 'none', background: '#eee', borderRadius: '8px', cursor: 'pointer' };
const saveBtn = { flex: 1, padding: '12px', border: 'none', background: '#D32F2F', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' };
const loadingStyle_full = { height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', color: '#666' };

export default CompetitorDashboard;
